module.exports = __webpack_public_path__ + "routes/StatusGmin/waiting-wheel-300x300.gif?04fcf026";


//////////////////
// WEBPACK FOOTER
// ./routes/StatusGmin/waiting-wheel-300x300.gif
// module id = 1819
// module chunks = 0